import http from '@/http'

export default {
    async listLogs (data) {
        try {
            const response = await http.post(`/sso/logs`, data)

            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
}